export const AchievementsData = [
  {
    id: 1,
    title: "Accenture Celebrates Excellence Award",
    organization: "Accenture",
    year: "2023",
    description: "Recognized for outstanding performance, innovation, and exceptional client service delivery.",
    category: "Professional Excellence"
  }
];
